import { withStyles } from '@material-ui/core';
import Downshift from 'downshift';

import Autocomplete from './component';
import styles from './styles';

export const { stateChangeTypes } = Downshift;

export default withStyles(styles)(Autocomplete);
